/** The member the public API acts as: one per workspace, named "API". */
export function isApiUser(user: { email?: string | null } | null | undefined) {
	return Boolean(user?.email?.endsWith("@rpc.productlane.io"))
}
